import { Box,Button,Flex,Select,InputGroup,
    InputLeftElement,Input, Heading, Text, 
    TableContainer,Table,Thead,Tbody,Th,Tr,Td, Image } from "@chakra-ui/react";
  import { DateFilter, TopDisplay} from "../../../components";
  import { LuSearch as SearchIcon } from "react-icons/lu";
  import { useState ,useEffect} from "react";
  import styled from "@emotion/styled";
  import { useMutation, useQuery, useQueryClient } from 'react-query';
  import apiCall from '../../../utils/apiCall';
  import { BsDownload as DownloadIcon } from "react-icons/bs";
  import { downloadApi } from "../../../api";
  import {useAtom,atom} from 'jotai'
  import { openAtom, notificationAtom, openNAtom, modalAtom } from "../../../context";
  import { Loader } from "../../../customs";
  import {TablePopUp} from '../../../components';
  import { TbReload as ReloadIcon } from "react-icons/tb";
  import ReactPaginate from 'react-paginate';
  import { format } from "date-fns";
  import { MdMoreVert as MoreIcon } from "react-icons/md";
  import {
    Grid,
    GridItem,
    Popover,
    PopoverTrigger,
    PopoverContent,
    PopoverHeader,
    PopoverBody,
    PopoverFooter,
    PopoverArrow,
    PopoverCloseButton,
    PopoverAnchor,
  } from '@chakra-ui/react'
  
  const indexAtom = atom<number | null>(null);
  const list = [
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
    {
      StudentId:Math.floor(Math.random() * 10000)+1,
      FirstName:'Abey',
      LastName:'Adesola',
      OldEmail:'Abey.Adesola@gmail.com',
      NewEmail:"Osakpolo@gmail.com",
      Reason:"Not working",
      DateRequested:"01-03-2024",
      Status:"Pending",
    },
  ]
  
  const HeadStyle={
    borderBottom:"1px solid var(--dark-green-color)",
    padding:'15px 5px',
  }
  const DataStyle = {
    padding:'5px 5px',
    thcolor:'var(--dark-green-color)'
  }
  
  
  const ROWSTYLE = styled.tr`
    & > td:last-of-type{
      width:50px;
      height:63px;
      & > div{
        display:none;
      }
    }
    &:hover > *{
      cursor: pointer;
      background-color:var(--table-highlight);
    } 
    & > td{
      width:140px;
    }
    &:hover > td:last-of-type{
      
      & > div{
        display: block;
      }
    }
    & > td > div.active{
      display: block;
    }
  `
  
  export default function StudentApplicationReport({ data }:any)  {
  const [hide,set_hide] = useState<boolean>(true);
  const [activeIndex] = useAtom(indexAtom);
  const queryClient = useQueryClient();
  const [,set_open] = useAtom(openAtom);
  // const [active] = useAtom<number | string | null>(ExamTimeTableAtom);
  const [,set_Nopen] = useAtom(openNAtom);
  const [,set_notification]= useAtom(notificationAtom);
  const [selected_examperiod,set_selected_examperiod] = useState<null | string>(null);
   const [selected_level,set_selected_level] = useState<null | string>(null);
   
  // const {data:allExamPeriod} = useQuery(['exam-period'],{
  //       queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
  //       select(data){
         
  //         return data.data.Data;
  //       },
  //     });
    
    const {data:allLevel} = useQuery(['exam-level'],{
        queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
        select(data){
          return data.data.Data;
        },
      })

    const [search, set_search] = useState('');
    const [debounced_search, set_debounced_search] = useState('');
    const itemsPerPage = 100;
    const [pageNumber, set_pageNumber] = useState(1);

    // Debounce the search box so typing doesn't fire a request per keystroke.
    useEffect(() => {
      const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
      return () => clearTimeout(timer);
    }, [search]);

    // Any change to filters/search invalidates the current page.
    useEffect(() => {
      set_pageNumber(1);
    }, [selected_level, debounced_search]);

    // One request per page, always - server applies PageNumber/PageSize plus
    // whichever filters are active. LevelId/StudentNo aren't 100% reliably
    // honored by this endpoint, so as a cheap (no extra request) safety net
    // we also re-check the real fields on just the page that came back,
    // instead of pre-fetching every page up front.
    const { data: pagedResult, isLoading } = useQuery(
      ['exam-application-page', selected_level, debounced_search, pageNumber],
      async () => {
        const params: Record<string, any> = {
          PageNumber: pageNumber,
          PageSize: itemsPerPage,
        };
        if (selected_level) params.LevelId = selected_level;
        if (debounced_search) params.StudentNo = debounced_search;

        const response = await apiCall().get(`Exam/GetAllNotRegisteredStudent`, { params });
        return response.data;
      },
      {
        keepPreviousData: true,
        select(data: any) {
          let items = data?.reportItems || [];
          if (selected_level) items = items.filter((d: any) => String(d.Level?.Id) === String(selected_level));
          if (debounced_search) {
            const term = debounced_search.toLowerCase();
            items = items.filter((d: any) => {
              const studentNo = d?.StudentNo?.toString().toLowerCase() || '';
              const fullName = `${d?.FirstName || ''} ${d?.LastName || ''}`.toLowerCase();
              return studentNo.includes(term) || fullName.includes(term);
            });
          }
          const totalCount = data?.TotalCount ?? items.length;
          return {
            items,
            totalCount,
            pageCount: data?.PageCount ?? Math.max(1, Math.ceil(totalCount / itemsPerPage)),
          };
        },
      }
    );

    const currentItems = pagedResult?.items || [];
    const totalCount = pagedResult?.totalCount ?? 0;
    const pageCount = pagedResult?.pageCount ?? 1;
    const itemOffset = (pageNumber - 1) * itemsPerPage;
    const endOffset = Math.min(itemOffset + itemsPerPage, totalCount);

    const handlePageClick = (event: any) => {
      set_pageNumber(event.selected + 1);
    };


    const {mutate:handleDownload,isLoading:isDownloading} = useMutation({
        mutationKey:[],
        mutationFn:async ()=> {
          
         let body:any = {};
         if(selected_examperiod)body.ExamPeriodId = Number(selected_examperiod);
         if(selected_level)body.LevelId = Number(selected_level);
         if(search)body.StudentNo=search;
         body = JSON.stringify(body);
          const url = `/ExamReport/downloadAllNotRegisteredStudentReport`,method = "POST",config = {'content-type':'application/json'},download = true;
          return await downloadApi(url,method,body,config,download)
    
        },
        onSuccess:async(data:any)=>{
          //initial the download 
          //console.log(data,'download data')
          let file = data;
         
          if(file && (!file.status || !file.statusCode) ){
            
            const url = window.URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "Application-report.xlsx");
            document.body.appendChild(link);
            link.click();
            //console.log(file,'data')
            set_notification({
              type:'success',
              message:data?.data?.Message || 'download Successfully'
            })
            set_Nopen(true);
          }
          else{
            set_notification({
              type:'error',
              message:data.Message || 'Oooops! Error Occured trying to download file'
            })
            set_Nopen(true);
          }
          
        },
        onError(error:any, variables, context) {
         // console.log(error,'error')
          set_notification({
            type:'error',
            message:error?.Message || error?.data?.Message  || 'Error Occured'
          })
          set_Nopen(true);
        },
        onSettled:()=>{
          set_open(false);
        }
    
      } )
  
    return (
      <>
     {isLoading?<Loader />:
  
      <Box>
        <TopDisplay label="Application Report" button_array={[
          
            <Button disabled={isDownloading} type="submit" color="var(--white-color)" 
            bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
            onClick={()=>handleDownload()} 
          > {isDownloading?"DownLoading":'Download Application Report'}</Button>,
           
          ]} />
          <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup width="300px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents="none">
              <SearchIcon color="gray.300" />
            </InputLeftElement>
            <Input
              type="text"
              value={search}
              onChange={(e) => set_search(e.target.value)}
              placeholder="Search by Student No or Name"
              bg="var(--white-color)"
              borderColor="var(--dark-green-color)"
            />
            <span
              style={{
                position: "absolute",
                zIndex: "1",
                right: "10px",
                cursor: "pointer",
                top: "12px",
              }}
              onClick={() => set_search("")}
            >
              <ReloadIcon />
            </span>
          </InputGroup>
              <Select
                placeholder="Level"
                width="140px"
                bg="var(--white-color)"
                borderColor="var(--dark-green-color)"
                onChange={(e: any) => set_selected_level(e.target.value || null)}
                name="LevelId"
              >
                {allLevel && allLevel.length > 0
                  ? allLevel.map((eType: any) => (
                      <option key={eType.Id} value={eType.Id}>
                        {eType.Name}
                      </option>
                    ))
                  : null}
              </Select>
            </Flex>
        
          <Flex mt="25px" flexDir="column" gap="10px">
            <Heading m="0" fontSize="1rem">All Application Report</Heading>
            <Text m="0" fontSize=".8rem">Showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}</Text>
          </Flex>
          {  currentItems && currentItems.length > 0 ?  <TableContainer mt="20px">
          <Table size='sm'>
            <Thead>
              <Tr >
              <Th sx={HeadStyle}>StudentNo</Th>
                <Th sx={HeadStyle}>First Name</Th>
                <Th sx={HeadStyle}>Last Name</Th>
                <Th sx={HeadStyle}>Level</Th>
                <Th sx={HeadStyle}>Phone</Th>
                <Th sx={HeadStyle}>Email</Th>
                <Th sx={HeadStyle}>Gender</Th>
                <Th sx={HeadStyle}>Address</Th>
                <Th sx={HeadStyle}>Reg.Date</Th>
                <Th sx={HeadStyle} w="50px"></Th>
              </Tr>
            </Thead>
            <Tbody>
            {currentItems.map((eUpgradeScore:any,index:number) =><ROWSTYLE key={eUpgradeScore.SN}>
                <Td sx={DataStyle}>{eUpgradeScore.StudentNo || 'N/a'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.FirstName ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.LastName ||'N/A'}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Level?eUpgradeScore.Level.ExemptionName:''}</Td>
                {/* <Td sx={DataStyle}>{allExamPeriod && allExamPeriod.find((ePeriod:any)=> ePeriod.Id == eUpgradeScore.ExamPeriodId)?.ExamName || 'N/A'}</Td> */}
                <Td sx={DataStyle}>{eUpgradeScore.PhoneNumber}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Email}</Td>
                <Td sx={DataStyle}>{eUpgradeScore.Gender}</Td>
                <Td title={eUpgradeScore?.Address} sx={{...DataStyle,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap',maxW:'150px'}}>{eUpgradeScore.Address ||'N/A'}</Td>
                <Td sx={DataStyle}>{format(new Date(eUpgradeScore.RegistrationDate), "dd/MM/yyyy")}</Td>
                
                <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                      <div className={activeIndex === index?'active':''}><Option {...{index,candidate:eUpgradeScore}}/></div>
                  </Td>
              </ROWSTYLE>
                )}
              </Tbody>
            </Table>
          </TableContainer>
          :'No Applications'  
        }
        <StylePaginateBox>
          <ReactPaginate
            breakLabel="..."
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="<"
            renderOnZeroPageCount={null}
          />
  
        </StylePaginateBox>
  
      </Box>
  }
  </>
    )
  }
  const StylePaginateBox = styled.div`
    width:100%;
    & > ul{
      list-style-type: none;
      text-align:center;
      padding:0;
      margin:0;
      margin-top:10px;
    } 
    & > ul > li{
      display: inline;
      margin:0 5px;
      padding:2px 5px;
      border-radius: 3px;
      background-color: transparent;
      color:var(--dark-green-color);
    }
    & > ul > li.selected{
      background-color: var(--highlight-paginate-background);
      color:var(--highlight-paginate-color);
    }
    & > ul > li:first-of-type,
    & > ul > li:last-of-type{
      font-weight: bold;
    }
  `
  const ExamTimeTableAtom = atom<number | null>(null);

  
  const sx={
    ':hover':{
      bg:'var(--content-background)'
    }
  }
  
  const Option = (props:any)=>{
    const index = props.index;
    const candidate= props.candidate;
    const [ind,set_index] = useAtom(indexAtom);
    const [,set_open] = useAtom(openAtom);
    const [,set_modal] = useAtom(modalAtom);
    const [,set_N_open] = useAtom(openNAtom);
    const [,set_notification] = useAtom(notificationAtom);
    const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
    const queryClient = useQueryClient();
    const {data:allLevels} = useQuery(['exam-level'],{
      queryFn:async ()=> await apiCall().get(`/SetUp/GetAllExemption`),
      select(data){
        return data.data.Data;
      }
    })
  
    useEffect(()=>{
      set_new_level(candidate?.Level?.Id)
    },[])
  
    const onClick=()=>{
      if(index === ind){
        set_index(null);
        return;
      }
      set_index(index);
    }
    const handleShowProfile = () =>{
      set_index(null);
      set_modal({
        header:'Application Details',
        content:<ViewProfile candidate={candidate} />
      })
      set_open(true);
    }
    useEffect(()=>{
      return ()=>set_index(null)
    },[])
    return(
      <Popover>
      <PopoverTrigger>
        <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
      </PopoverTrigger>
      <PopoverContent width="fit-content">
        <PopoverArrow />
        <PopoverBody>
          <Grid templateColumns="1fr" p="6px">
            <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
          </Grid>
        </PopoverBody>
      </PopoverContent>
    </Popover>
    )
  }
  
  const ViewProfile = (props: any) => {
    // Default image URL
    const defaultImage = "/public-assets/profile-not-found.png"; // Path to your default image
    const imageUrl = props.candidate?.ImageUrl || defaultImage; // Use default image if ImageUrl is not available

    return (
        <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
            <Flex align="center" gap="20px">
                <Image
                    src={imageUrl} // Use the imageUrl variable here
                    width="100px"
                    height="100px"
                    borderRadius="10%"
                    objectFit="cover"
                    objectPosition="center"
                    alt="No image found"
                    fallbackSrc={defaultImage} 
                />
                <Flex flexDir="column">
                    <Heading fontSize="1rem">{`${props.candidate.FirstName} ${props.candidate.LastName}`}</Heading>
                    <Text>Student</Text>
                    <Text>ID: {props.candidate.StudentNo}</Text>
                </Flex>
            </Flex>
            <Grid templateColumns="repeat(3, 1fr)" gap="30px">
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Present Level</Text>
                    <Text fontWeight="500">{props.candidate?.Level?.ExemptionName}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Amount Paid</Text>
                    <Text fontWeight="500"># {props.candidate.Amount}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Study Center</Text>
                    <Text fontWeight="500">{props.candidate.StudyCenter || 'Study Center 1'}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Application Date</Text>
                    <Text fontWeight="500">{format(new Date(props.candidate.RegistrationDate), "dd/MM/yyyy")}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
                    <Text fontWeight="500">{props.candidate.Email}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Gender</Text>
                    <Text fontWeight="500">{props.candidate.Gender}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
                    <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
                </GridItem>
                <GridItem>
                    <Text fontWeight="500" color="var(--light-text)">Address</Text>
                    <Text fontWeight="500">{props.candidate.Address}</Text>
                </GridItem>
            </Grid>
        </Flex>
    )}